import styled from "styled-components";
import { SPACING } from "../../utils/constants";
import { HelperText } from "../MobileForm/styles";

export const MobileHelper = styled(HelperText)`
  margin-top: ${SPACING.xs}px;
  padding: 0;
`;
